import { AspectRatio, Image } from '@mantine/core'
import { Typography } from '../../common/typography'
import classes from './TeamComponents.module.css'

export default function TeamCaptainBox({
  name,
  photo,
}: {
  name: string
  photo: string
}) {
  const isPlaceholderPhoto = /\.svg$/i.test(photo)

  return (
    <div className={classes.teamCaptainContainer}>
      <AspectRatio ratio={1 / 1}>
        <Image
          src={photo}
          alt={name}
          className={classes.teamCaptain}
          fit={isPlaceholderPhoto ? 'contain' : 'scale-down'}
        />
      </AspectRatio>
      <div className={classes.teamCaptainWrapper}>
        <Typography fs="sm" fw={500} lh="115">
          Team Captain
        </Typography>
        <Typography lh="125">{name}</Typography>
      </div>
    </div>
  )
}
